/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Tss_RangeInputs */

const en_exp_tss_range = /** @type {(inputs: Exp_Tss_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under 150: low stress, quick recovery. 150-300: moderate, some residual fatigue. 300-450: high, requires 2+ days recovery. 450+: very high, extended recovery needed.`)
};

const de_exp_tss_range = /** @type {(inputs: Exp_Tss_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unter 150: geringe Belastung, schnelle Erholung. 150–300: moderat, etwas Restmüdigkeit. 300–450: hoch, 2+ Tage Erholung. 450+: sehr hoch, lange Erholung nötig.`)
};

/**
* | output |
* | --- |
* | "Under 150: low stress, quick recovery. 150-300: moderate, some residual fatigue. 300-450: high, requires 2+ days recovery. 450+: very high, extended recovery..." |
*
* @param {Exp_Tss_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_tss_range = /** @type {((inputs?: Exp_Tss_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Tss_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_tss_range(inputs)
	return de_exp_tss_range(inputs)
});